module.exports = __webpack_public_path__ + "img/form-brillant.183d7f3.png";